import React from "react";
import moujibLogo from "../../assets/logo/logo-moujib.png";

interface LogoProps {
  size?: "sm" | "md" | "lg" | "xl" | "xxl" | "xxxl";
  variant?: "light" | "dark" | "color";
  showText?: boolean;
  className?: string;
}

export const MoujibLogo: React.FC<LogoProps> = ({
  size = "md",

  className = "",
}) => {
  const sizes = {
    sm: { icon: "w-6 h-6", text: "text-lg" },
    md: { icon: "w-8 h-8", text: "text-xl" },
    lg: { icon: "w-12 h-12", text: "text-2xl" },
    xl: { icon: "w-16 h-16", text: "text-3xl" },
    xxl: { icon: "w-20 h-20", text: "text-4xl" },
    xxxl: { icon: "w-32 h-32", text: "text-5xl" },
  };

  const currentSize = sizes[size];

  return (
    <div className={`flex items-center space-x-3 ${className}`}>
      {/* Logo Icon - Speech bubble with Arabic aesthetic */}
      <div className={`${currentSize.icon} relative`}>
        <img
          src={moujibLogo}
          alt="Comments illustration"
          className="w-full h-auto"
        />
      </div>
    </div>
  );
};

// Simplified logo for favicons and small spaces
export const MoujibIcon: React.FC<{ size?: number; className?: string }> = ({
  size = 32,
  className = "",
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <linearGradient id="iconGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#3B82F6" />
          <stop offset="100%" stopColor="#1D4ED8" />
        </linearGradient>
      </defs>

      <path
        d="M48 12H16C10.48 12 6 16.48 6 22v16c0 5.52 4.48 10 10 10h6l8 8 8-8h10c5.52 0 10-4.48 10-10V22c0-5.52-4.48-10-10-10z"
        fill="url(#iconGradient)"
      />

      <circle cx="20" cy="28" r="2" fill="white" opacity="0.9" />
      <circle cx="32" cy="28" r="2" fill="white" opacity="0.9" />
      <circle cx="44" cy="28" r="2" fill="white" opacity="0.9" />

      <path
        d="M16 20h32"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        opacity="0.7"
      />
    </svg>
  );
};

export default MoujibLogo;
